import Image from "next/image";
import { useState, useEffect } from "react";

import { isMobile } from "@/utils/deviceJudgment";
import closeSearchIcon from "@/assets/icons/close-search.svg";
import searchIcon from "@/assets/icons/search.svg";
import taskIcon from "@/assets/icons/new-request.svg";
import houseIcon from "@/assets/icons/house-icon.svg";
import userIcon from "@/assets/icons/user.svg";

import styles from "./index.module.scss";

type Props = {
  word: string;
  typing: boolean;
  activeType: string;
  searchType: "venue" | "contract";
  setWord: React.Dispatch<React.SetStateAction<string>>;
  isSearched: boolean;
  setFirstSearch: React.Dispatch<React.SetStateAction<boolean>>;
  setKeyDownEnter: React.Dispatch<React.SetStateAction<boolean>>;
  setTyping: React.Dispatch<React.SetStateAction<boolean>>;
  setActiveType: React.Dispatch<React.SetStateAction<string>>;
  clearSerachResult: () => void;
};

/* 検索ワード入力 */
const WordInput: React.FC<Props> = ({
  word,
  typing,
  activeType,
  searchType,
  setWord,
  isSearched,
  setFirstSearch,
  setKeyDownEnter,
  setTyping,
  setActiveType,
  clearSerachResult
}) => {
  const [isSearchedCheck, setIsSearchedCheck] = useState(false);

  //検索済みか判定
  useEffect(() => {
    setIsSearchedCheck(
      word && (isSearched || searchType === "contract") ? true : false
    );
  }, [word, isSearched, searchType]);

  return (
    <>
      <div>
        <input
          className={
            isSearchedCheck
              ? activeType
                ? styles.search__searched
                : styles.search__no_type_searched
              : styles.search
          }
          type="text"
          value={word}
          placeholder="物件、住所、仕事、クルーを検索"
          onChange={(e) => {
            setWord(e.target.value);
            setFirstSearch(true);
            setActiveType("");
          }}
          onCompositionStart={() => setTyping(true)}
          onCompositionEnd={() => setTyping(false)}
          onBlur={() => {
            //スマホの時のみ発火
            if (!typing && word && isMobile()) setKeyDownEnter(true);
          }}
          onKeyDown={(e: any) => {
            if (e.key !== "Enter" || typing) return;
            setKeyDownEnter(true);
          }}
        />
      </div>
      {(word || isSearched) && activeType && (
        <div className="absolute left-[1.25rem] top-12 w-16">
          <Image
            src={
              activeType === "venue"
                ? houseIcon
                : activeType === "user"
                  ? userIcon
                  : taskIcon
            }
            alt="検索結果識別アイコン"
          />
        </div>
      )}
      {/* 検索/closeアイコン */}
      <div
        className={
          isSearchedCheck
            ? styles.close_icon_wrapper
            : styles.search_icon_wrapper
        }
        onClick={clearSerachResult}
      >
        <Image
          src={isSearchedCheck ? closeSearchIcon : searchIcon}
          alt="アイコン"
        />
      </div>
    </>
  );
};

export default WordInput;
